<template>
  <div id="roots">
    <div class="top clearfix">
      <i class="el-icon-menu"></i>
      <div class="msgTitle">添加商品</div>
      <div class="button">
        <el-button class="excelBtn" type="primary" icon="el-icon-plus" @click="Model">添加批次</el-button>
      </div>
    </div>
    <div class="container clearfix">
      <div class="tops">
        <div v-for="(item,index) in batchData" :key = "index" style="float:left">
          <div class="btns clearfix">
            <div class="line" v-if='index !==0'>
            </div>
              <div class="title" :class="{'color30c':index ==0}">{{item.batchName}}</div>
            <div class="btn" :class="{'bg':index ==0}">{{index}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="form">
        <el-form
          :model="dynamicValidateForm"
          label-width="100px"
          class="demo-dynamic"
        >
          <el-form-item prop="email" label="库存">
            <el-input class="width150" v-model="dynamicValidateForm.email"></el-input>
            <i class="el-icon-edit fl"></i>
          </el-form-item>
          <el-form-item
            v-for="(domain, index) in dynamicValidateForm.domains"
            :label="'日期'"
            :key="domain.key"
            :prop="'domains.' + index + '.value'"
          >
            <el-date-picker v-model="domain.input" type="datetime" placeholder="选择日期时间"></el-date-picker>
            <el-input v-model="domain.value" placeholder="请输入内容" class="width300"></el-input>
          </el-form-item>
          <el-form-item>
            <!-- <el-button type="primary" @click="submitForm('dynamicValidateForm')">提交</el-button> -->
            <el-button class="addNew" icon="el-icon-circle-plus-outline" @click="addDomain">新增</el-button>
          </el-form-item>
        </el-form>
        <div class="btnBox">
          <el-button class="save" @click="submitForm('dynamicValidateForm')">提交</el-button>
        </div>
      </div>
    </div>
    <div id="model" v-if="show">
      <div class="title">添加新批次</div>
      <div class="boxInput">
        <div class="oneBox clearfix">
          <div class="name">批次名称</div>
          <input class="inputBox" type="text" v-model="batchName" />
        </div>
        <div class="oneBox clearfix top20">
          <div class="name">库存(件)</div>
          <input class="inputBox" type="text" v-model="batchCount" />
        </div>
      </div>
      <div class="btnBox clearfix">
        <div class="cancel" @click="cancel">取消</div>
        <div class="leftBorder"></div>
        <div class="affirm" @click="addBatch">确认</div>
      </div>
    </div>
  </div>
</template>
 <script>
import { addbatch, getbatch } from "@/api/goods";
import { mapGetters, mapActions } from "vuex";
export default {
  created() {
    this.getBatch();
  },
  data() {
    return {
      dynamicValidateForm: {
        domains: [
          {
            value: "",
            input: ""
          }
        ],
        email: ""
      },
      batchName: "",
      batchCount: "",
      value1: "",
      show: false,
      batchData: []
    };
  },
  computed: {
    ...mapGetters(["chooseCompany", "companyList", "mchId"])
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addDomain() {
      this.dynamicValidateForm.domains.push({
        value: "",
        key: Date.now()
      });
    },
    addBatch() {
      let data = {
        batchName: this.batchName,
        count: this.batchCount,
        goodId: this.$route.params.id,
        mchId: this.chooseCompany.id
      };
      addbatch(data).then(res => {
        if (res.status == 200) {
          this.show = false;

          this.$message({
            type: "info",
            message: "添加成功"
          });
          this.$router.push({
            path: "/main/storeUp"
          });
        }
      });
    },
    Model() {
      this.show = true;
    },
    cancel() {
      this.show = false;
    },
    getBatch() {
      let data = {
        goodId: this.$route.params.id
      };
      getbatch(data).then(res => {
        if (res.status == 200) {
          this.batchData = res.data;
        }
      });
    }
  }
};
</script>

 <style lang='scss' scoped>
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
#roots {
  width: 100%;
  padding: 0px 5px 5px 26px;
  box-sizing: border-box;
  .bg{
    background:rgba(48,206,122,1);
    color: #FFFFFF !important;
  }
  .color30c{
    color: #30CE7A
  }
  .top {
    border-bottom: 1px solid #ebf1f3;
    height: 75px;
    i {
      float: left;
      height: 40px;
      line-height: 40px;
    }
    .msgTitle {
      float: left;
      height: 40px;
      line-height: 40px;
    }
    .button {
      float: right;
    }
  }
  .container {
    padding: 30px 120px;
    box-sizing: border-box;
    .btns {
      position: relative;
      height: 140px;
      .title {
          width: 89px;
          height: 70px;
          position: absolute;
          right: -22px;
          top: 43px;
          background: url("../assets/images/bac.png") no-repeat;
          text-align: center;
          font-size: 12px;
          padding-top: 25px;
        }
      .line {
        width: 170px;
        border-bottom: 2px solid #ebf1f3;
        float: left;
        margin-top: 20px;
        position: relative;
        // .title {
        //   width: 89px;
        //   height: 70px;
        //   position: absolute;
        //   right: -65px;
        //   top: 23px;
        //   background: url("../assets/images/bac.png") no-repeat;
        //   text-align: center;
        //   font-size: 12px;
        //   padding-top: 25px;
        // }
      }
      .btn {
        width: 42px;
        height: 42px;
        border: 1px solid #30ce7a;
        text-align: center;
        line-height: 42px;
        border-radius: 50%;
        color: #30ce7a;
        float: left;
      }
    }
  }
  .bottom {
    width: 100%;
    padding: 0 129px 0 102px;
    box-sizing: border-box;
    .form {
      padding: 22px 0;
      background-color: #ecf0f1;
    }
  }
  .width300 {
    width: 300px;
  }
  .width150 {
    width: 150px;
  }
  .addNew {
    background: none;
    color: #3dd278;
    border: none;
    padding-left: 0;
  }
  .save {
    width: 120px;
    height: 36px;
    background-color: #3dd278;
    color: #fff;
  }
  .btnBox {
    width: 100%;
    text-align: center;
  }
  .fl {
    width: 30px;
    height: 30px;
    margin-left: 5px;
    color: #3dd278;
    cursor: pointer;
  }
  #model {
    width: 400px;
    height: 223px;
    position: fixed;
    left: 50%;
    top: 50%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 11px 0px rgba(49, 207, 128, 0.3);
    transform: translate(-200px, -110px);
    -ms-transform: translate(-200px, -110px); /* IE 9 */
    -moz-transform: translate(-200px, -110px); /* Firefox */
    -webkit-transform: translate(-200px, -110px); /* Safari 和 Chrome */
    -o-transform: translate(-200px, -110px);
    border-radius: 5px;
    .title {
      width: 100%;
      height: 40px;
      background-color: #dbe2de;
      text-align: center;
      line-height: 41px;
      border-radius: 5px 5px 0 0;
      color: #5d6a73;
    }
    .boxInput {
      padding: 14px 30px;
      box-sizing: border-box;
      .oneBox {
        height: 38px;
        .name {
          width: 78px;
          height: 100%;
          line-height: 40px;
          color: #5d6a73;
          float: left;
        }
        .inputBox {
          width: 240px;
          height: 38px;
        }
      }
    }
    .btnBox {
      width: 100%;
      border-top: 1px solid #dce6e8;
      height: 58px;
      .cancel {
        color: #30ce7d;
        width: 199.5px;
        float: left;
        line-height: 58px;
        cursor: pointer;
      }
      .affirm {
        color: #526069;
        width: 199.5px;
        float: right;
        line-height: 58px;
        cursor: pointer;
      }
      .leftBorder {
        height: 100%;
        float: left;
        border-left: 1px solid #d8d8d8;
      }
    }
  }
}
.top20 {
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/roots.vue